import React from 'react'
import {render} from 'react-dom'
import {BrowserRouter, Route, Switch} from 'react-router-dom'

import Login from './views/Login.js'
import Layout from './views/Layout.js'
import ErrorBoundary from '../src/components/UI/feedback/ErrorBoundary.js'

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js', {scope: '/koerier'})
        .then((registration) => {
            console.log('Registration successful, scope is:', registration.scope)
        })
        .catch((err) => {
            console.log('Service worker registration failed, error:', err)
        })
}

const router = (
    <ErrorBoundary>
        <BrowserRouter>
            <Switch>
                <Route path='/koerier/login' component={Login} />
                <Route path='/koerier' component={Layout} />
            </Switch>
        </BrowserRouter>
    </ErrorBoundary>
)

render(router, document.getElementById('react-container'))
